import { memo } from "react";
import { useRedemptionsStore } from "@/hooks";
import { RedemptionQueueContent } from "./RedemptionQueueContent";

export const RedemptionQueue = memo(function RedemptionQueue() {
    const { redemptionsData, isLoading } = useRedemptionsStore();

    return <RedemptionQueueContent redemptionsData={redemptionsData} isLoading={isLoading} />;
});

RedemptionQueue.displayName = "RedemptionQueue";
